import { render, staticRenderFns } from "./chooseLogin.vue?vue&type=template&id=4f555d2a"
import script from "./chooseLogin.vue?vue&type=script&lang=js"
export * from "./chooseLogin.vue?vue&type=script&lang=js"
import style0 from "./chooseLogin.vue?vue&type=style&index=0&id=4f555d2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports